"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const app_1 = require("../app");
const booking_cancel_window_1 = require("../app/components/booking/booking_cancel_window");
const client_booking_cancel_window_1 = require("../app/components/booking/client_booking_cancel_window");
const calendar_day_1 = require("../model/calendar_day");
const venue_1 = require("../model/venue");
const auth_1 = require("../utils/auth");
const delayed_1 = require("../utils/delayed");
const helpers_1 = require("../utils/helpers");
const frozen_panes_1 = require("../widgets/frozen_panes");
const right_panel_1 = require("../widgets/right_panel");
const booking_window_1 = require("./booking_window");
const day_slot_1 = require("./day_slot");
const edit_booking_window_1 = require("./edit_booking_window");
const dayModel = new calendar_day_1.CalendarDay();
var venueList = [];
function showCancelWindow(booking) {
    if (auth_1.Auth.isAdmin()) {
        booking_cancel_window_1.BookingCancelWindow.show(booking);
    }
    else {
        client_booking_cancel_window_1.ClientBookingCancelWindow.show(booking.details.id, (0, moment_timezone_1.default)(booking.from), booking.duration);
    }
}
function showEditWindow(booking) {
    edit_booking_window_1.EditBookingWindow.edit(booking.details.id);
}
let tooltipTarget = undefined;
const findBooking = function (n) {
    if (!n) {
        return null;
    }
    if (n.classList.contains("mcal-booking-active")) {
        return n;
    }
    else {
        return findBooking(n.parentElement);
    }
};
let movePopover = (evt) => {
    evt.redraw = false;
    let bookingElm = findBooking(evt.target);
    if (bookingElm) {
        evt.stopPropagation();
        evt.preventDefault();
        const calendar = exports.Calendar.dom;
        const offset = (0, helpers_1.getOffset)(evt.target);
        const offsetCalendar = (0, helpers_1.getOffset)(calendar);
        const x = offset.left - offsetCalendar.left + evt.offsetX;
        const y = offset.top - offsetCalendar.top + evt.offsetY;
        const maxWidth = calendar.clientWidth, maxHeight = calendar.clientHeight;
        let newToolTip = {
            booking: dayModel.getBooking(parseInt(bookingElm.dataset.id))
        };
        if (x < 0.5 * maxWidth) {
            newToolTip.left = x + 10;
            newToolTip.right = undefined;
        }
        else {
            newToolTip.left = undefined;
            newToolTip.right = (maxWidth - x) + 10;
        }
        if (y < 0.5 * maxHeight) {
            newToolTip.top = y + 10;
            newToolTip.bottom = undefined;
        }
        else {
            newToolTip.top = undefined;
            newToolTip.bottom = (maxHeight - y) + 10;
        }
        if (!tooltipTarget || (newToolTip.booking != tooltipTarget.booking))
            (0, delayed_1.delayed)("tooltip", mithril_1.default.redraw);
        tooltipTarget = newToolTip;
    }
    else {
        if (tooltipTarget != undefined)
            (0, delayed_1.delayed)("tooltip", mithril_1.default.redraw);
        tooltipTarget = undefined;
    }
};
exports.Calendar = {
    editMode: false,
    dom: undefined,
    totalTime() {
        let start = this.startTime();
        let end = this.endTime();
        return end - start;
    },
    dayModel() {
        return dayModel;
    },
    refresh() {
        dayModel.fetch();
    },
    startTime() {
        let [startHour, startMinute] = dayModel.data.venue.planning_starts_at.split(/:/).map(e => parseInt(e));
        return startHour * 60 + startMinute;
    },
    endTime() {
        let [endHour, endMinute] = dayModel.data.venue.planning_ends_at.split(/:/).map(e => parseInt(e));
        return endHour * 60 + endMinute;
    },
    isEditMode() {
        return auth_1.Auth.isAdmin() && this.editMode;
    },
    renderCalendarRoom(room, roomNumber) {
        let timeBlocks = [];
        let totalTime = exports.Calendar.totalTime();
        // let rulerSizeInPercent = 100 * (App.BOOKING_STEP / totalTime);
        let startTime = this.startTime();
        let currentStop = dayModel.day.tz(app_1.App.BOOKING_TIMEZONE).clone().startOf('day').add(startTime, "minutes");
        let now = (0, moment_timezone_1.default)();
        for (let i = 0; i < totalTime; i += app_1.App.BOOKING_STEP) {
            let disabled = room.id !== null && currentStop.isBefore(now);
            timeBlocks.push((0, day_slot_1.createTimeBlock)(dayModel, startTime + i, currentStop, room, disabled));
            currentStop.add(app_1.App.BOOKING_STEP, "minutes");
        }
        let bookings = [];
        const percentWidth = `${100.0 / roomNumber}%`;
        room.bookings.forEach((booking) => {
            var _a, _b;
            let start = app_1.App.moment(booking.from);
            let duration = booking.duration;
            let mn = start.minute();
            let hr = start.hour();
            let height = 100 * (duration / totalTime);
            let position = 100 * ((mn + hr * 60) - startTime) / totalTime;
            let loadingMark = undefined;
            if (booking.loading) {
                loadingMark = (0, mithril_1.default)("div", { style: "position: absolute; top: 5px; left: 5px;" }, (0, helpers_1.iconSpan)("fa-spinner fa-spin"));
            }
            let positionStyle = `height: calc(${height}% - 0px); top: ${position}%;`;
            const key = [room === null || room === void 0 ? void 0 : room.id, booking.from].join("-");
            if (booking.details) {
                let details = booking.details;
                let realStart = app_1.App.moment(booking.real_from);
                let realEnd = app_1.App.moment(booking.real_to);
                let warning = auth_1.Auth.isAdmin() && (details.client.has_mail || details.client.should_deliver_payment);
                let comment = auth_1.Auth.isAdmin() && (((_a = details.shared_comment) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = details.company_comment) === null || _b === void 0 ? void 0 : _b.length) > 0);
                bookings.push((0, mithril_1.default)("div", {
                    class: `mcal-booking-slot mcal-booking-active parent mcal-booking-duration-${duration}`,
                    style: positionStyle,
                    draggable: auth_1.Auth.isAdmin(),
                    key: key,
                    "data-id": details.id,
                    onclick: ((details) => () => {
                        right_panel_1.RightPanel.open("bookings", details.id, "show");
                    })(details),
                    ondragstart: (e) => {
                        if (details) {
                            e.dataTransfer.setData('booking_id', details.id);
                            e.dataTransfer.setData('booking_date', (0, moment_timezone_1.default)(booking.from).format());
                        }
                    }
                }, (0, mithril_1.default)("div.buttons-top", (0, mithril_1.default)("a.edit.visible-hover-only", {
                    href: "#",
                    onclick: (evt) => {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (details) {
                            showEditWindow(booking);
                        }
                    }
                }, (0, helpers_1.iconSpan)("fa-pen")), (0, mithril_1.default)("a.delete.visible-hover-only", {
                    href: "#",
                    onclick: (evt) => {
                        evt.preventDefault();
                        evt.stopPropagation();
                        if (details) {
                            showCancelWindow(booking);
                        }
                    }
                })), (0, helpers_1.level)({
                    left: (0, mithril_1.default)(".time", `${realStart.format("HH:mm")}-${realEnd.format("HH:mm")}`, warning ? (0, helpers_1.iconSpan)("fa-exclamation-triangle") : undefined, comment ? (0, helpers_1.iconSpan)("fa-comment-dots") : undefined),
                    right: (0, mithril_1.default)(".time", details.additional_services.join(",")),
                }), (0, helpers_1.ifTrue)(auth_1.Auth.isAdmin(), (0, mithril_1.default)("div", { class: "name" }, details.client.name)), (0, helpers_1.ifTrue)(auth_1.Auth.isAdmin(), (0, mithril_1.default)("p.summary", { title: details.company_comment }, details.company_comment), (0, mithril_1.default)("p.summary", { title: details.client_comment }, details.client_comment)), loadingMark));
            }
            else {
                bookings.push((0, mithril_1.default)(".mcal-booking-slot.mcal-booking-shadow", { style: positionStyle, key: key }));
            }
        });
        let klazz = (room.id === null) ? "for-edition" : "";
        return (0, mithril_1.default)(`.mcal-booking-room.mcal-booking-room-${room.id}`, { class: klazz, style: `width: ${percentWidth}` }, timeBlocks, bookings);
    },
    renderRoomsTitle() {
        const count = dayModel.data.rooms.length - (this.isEditMode() ? 0 : 1);
        return (0, mithril_1.default)(".mcal-room-titles", dayModel.data.rooms.map((room) => {
            if (room.id === null && !this.isEditMode()) {
                return undefined;
            }
            let klazz = (room.id === null) ? "for-edition" : undefined;
            return (0, mithril_1.default)("div", { class: klazz, style: `width: ${100.0 / count}%` }, room.name);
        }));
    },
    renderCalendar() {
        return (0, mithril_1.default)(".mcal-rooms.columns.is-mobile", dayModel.data.rooms.map((room) => {
            if (room.id === null && !this.isEditMode()) {
                return undefined;
            }
            return this.renderCalendarRoom(room, dayModel.data.rooms.length - (this.isEditMode() ? 0 : 1));
        }));
    },
    renderTime() {
        let o = [];
        let totalTime = this.endTime() - this.startTime();
        for (let i = this.startTime(); i < this.endTime(); i += 60) {
            let hour = i / 60;
            let height = 100 * (60.0 / totalTime);
            o.push((0, mithril_1.default)("div", { style: `height: ${height}%` }, (0, mithril_1.default)("span", `${hour}:00`)));
        }
        return (0, mithril_1.default)("div", { class: "mcal-hours" }, o);
    },
    toggleEditionMode() {
        this.editMode = !this.editMode;
    },
    allowEditMode() {
        return auth_1.Auth.isAdmin() && !dayModel.hasMeetingInTempZone();
    },
    renderDateSelect() {
        return (0, mithril_1.default)("p", { style: "max-width: 15rem;" }, (0, helpers_1.inputWithIcon)("fa-calendar", {
            type: "date",
            required: true,
            value: dayModel.day.tz(app_1.App.BOOKING_TIMEZONE).format("YYYY-MM-DD"),
            onchange: (evt) => {
                if (evt.target.value !== "") {
                    dayModel.day = moment_timezone_1.default.tz(evt.target.value, "YYYY-MM-DD", app_1.App.BOOKING_TIMEZONE);
                }
                else {
                    dayModel.day = (0, moment_timezone_1.default)();
                }
                exports.Calendar.refresh();
            }
        }));
    },
    renderVenueSelect() {
        let options = venueList.map((e) => {
            if (e.id == dayModel.venueId) {
                return (0, mithril_1.default)("option", { value: e.id, selected: true }, e.name);
            }
            else {
                return (0, mithril_1.default)("option", { value: e.id }, e.name);
            }
        });
        return (0, mithril_1.default)("div", { class: "control has-icons-left" }, (0, mithril_1.default)("div", { class: "select" }, (0, mithril_1.default)("select", { onupdate: (e) => {
                dayModel.venueId = e.target.value;
                exports.Calendar.refresh();
            } }, options)), (0, helpers_1.iconSpan)("fa-store", "is-left"));
    },
    renderLoading() {
        return (0, mithril_1.default)(".column.is-full", (0, mithril_1.default)(".columns.is-vcentered.has-text-centered", { style: "height: 100%" }, (0, mithril_1.default)(".column.is-full", (0, helpers_1.iconSpan)("fa-spinner", "fa-pulse is-size-1 has-text-primary"), (0, mithril_1.default)("div", { style: "margin-top: 1.0em" }, "Chargement..."))));
    },
    onremove(node) {
        let dom = node.dom;
        if (dom)
            dom.removeEventListener('mousemove', movePopover);
    },
    oncreate(node) {
        exports.Calendar.dom = node.dom;
        (0, venue_1.listVenues)().then((venues) => {
            venueList = venues;
            dayModel.venueId = venueList[0].id;
            exports.Calendar.refresh();
        }).catch((_err) => {
            dayModel.status = "error";
        });
        let dom = node.dom;
        dom.addEventListener('mousemove', movePopover);
    },
    renderPopover() {
        var _a, _b;
        if (tooltipTarget) {
            let details = tooltipTarget.booking.details;
            let left = "left: " + (tooltipTarget.left ? `${tooltipTarget.left}px` : "auto");
            let right = "right: " + (tooltipTarget.right ? `${tooltipTarget.right}px` : "auto");
            let bottom = "bottom: " + (tooltipTarget.bottom ? `${tooltipTarget.bottom}px` : "auto");
            let top = "top: " + (tooltipTarget.top ? `${tooltipTarget.top}px` : "auto");
            let absPos = [left, right, bottom, top].join("; ");
            let tooltipContent = [];
            tooltipContent.push((0, mithril_1.default)("div", `Réservation #${details.id}`));
            tooltipContent.push((0, mithril_1.default)("div", `Posée le ${app_1.App.moment(details.created_at).format("LLL")} CET`));
            if (details.additional_services.length > 0) {
                tooltipContent.push((0, mithril_1.default)("div", details.additional_services.join("\n")));
            }
            if (((_a = details.company_comment) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                tooltipContent.push((0, mithril_1.default)("p", details.company_comment));
            }
            if (((_b = details.shared_comment) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                tooltipContent.push((0, mithril_1.default)("p", details.shared_comment));
            }
            if (auth_1.Auth.isAdmin()) {
                if (details.client.has_mail) {
                    tooltipContent.push((0, mithril_1.default)("p", (0, helpers_1.iconSpan)("fa-exclamation-triangle"), "Il y a du courrier pour ce client"));
                }
                if (details.client.should_deliver_payment) {
                    tooltipContent.push((0, mithril_1.default)("p", (0, helpers_1.iconSpan)("fa-exclamation-triangle"), "Le client doit amener les chèques"));
                }
            }
            tooltipContent = tooltipContent.map((x, idx) => {
                if (idx == 0)
                    return x;
                return [(0, mithril_1.default)("hr"), x];
            });
            return (0, mithril_1.default)("div", { class: "mcal-popover", style: absPos }, tooltipContent);
        }
        return undefined;
    },
    pane: new frozen_panes_1.FrozenPanes({
        top: function () { return exports.Calendar.renderRoomsTitle(); },
        content: function () { return exports.Calendar.renderCalendar(); },
        left: function () { return exports.Calendar.renderTime(); }
    }),
    view() {
        exports.Calendar.editMode = exports.Calendar.editMode || dayModel.hasMeetingInTempZone();
        const createAdvanceDay = (offset) => {
            return () => {
                dayModel.day.add(offset, "day");
                exports.Calendar.refresh();
            };
        };
        switch (dayModel.status) {
            case "loaded":
                return (0, mithril_1.default)("div", { class: "mcal-widget" }, (0, mithril_1.default)(".mcal-toolbox", (0, mithril_1.default)("div", this.renderDateSelect()), (0, mithril_1.default)(".mcal-buttons", (0, helpers_1.buttonGroup)((0, mithril_1.default)("a.mcal-button", { class: "button", onclick: createAdvanceDay(-1) }, (0, helpers_1.iconSpan)("fa-caret-left")), (0, mithril_1.default)("a.mcal-button", { class: "button", onclick: () => { dayModel.day = (0, moment_timezone_1.default)(); exports.Calendar.refresh(); } }, "Aujourd'hui"), (0, mithril_1.default)("a.mcal-button", { class: "button", onclick: createAdvanceDay(1) }, (0, helpers_1.iconSpan)("fa-caret-right"))))), (0, mithril_1.default)(".mcal-booking", [
                    (0, mithril_1.default)(".mcal-booking-container", (0, mithril_1.default)(this.pane)
                    // m("div", { class: "mcal-column mcal-left" }, [
                    //   /* Small top left box */     m("div", { class: "mcal-top-left" }, [
                    // ]),
                    //   /* The hours of the day */   m("div", {class: "mcal-bottom mcal-hours"}, this.renderTime()),
                    // ]),
                    // m("div", {class: "mcal-column mcal-right"} , [
                    //   /* Room headers */           m("div", {class: "mcal-top-right"}, this.renderRoomsTitle()),
                    //   /* The allmighty calendar */ m("div", {class: "mcal-bottom"}, this.renderCalendar())
                    // ]),
                    )
                ]), this.renderPopover(), (0, mithril_1.default)(booking_window_1.BookingWindow));
            case "error":
                return (0, mithril_1.default)("div", `Erreur inattendue, merci de recharger la page.`);
            default:
                return (0, mithril_1.default)("div", { class: "mcal-widget" }, (0, mithril_1.default)(".mcal-toolbox", (0, mithril_1.default)("div", this.renderDateSelect()), (0, mithril_1.default)(".mcal-buttons", (0, helpers_1.buttonGroup)((0, mithril_1.default)("a.mcal-button", { class: "button", onclick: createAdvanceDay(-1) }, (0, helpers_1.iconSpan)("fa-caret-left")), (0, mithril_1.default)("a.mcal-button", { class: "button", onclick: () => { dayModel.day = (0, moment_timezone_1.default)(); exports.Calendar.refresh(); } }, "Aujourd'hui"), (0, mithril_1.default)("a.mcal-button", { class: "button", onclick: createAdvanceDay(1) }, (0, helpers_1.iconSpan)("fa-caret-right"))))), (0, mithril_1.default)(".mcal-booking", [
                    (0, mithril_1.default)(".mcal-booking-container", this.renderLoading())
                ]));
        }
    }
};
